module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_9005.e639ded2.png";